module.exports = __webpack_public_path__ + "static/media/faith_2.5dbce53e.jpg";